import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import { useSchedulerHeaderStyles } from './styles'

interface Props {
    value: number
    onChange: (tab: number) => void
}

export const SchedulerHeaderTypeOfAnalytics = (props: Props) => {
    const classes = useSchedulerHeaderStyles()
    const { value, onChange } = props

    return (
        <Box className={classes.typeOfAnalyticsBox}>
            <Typography
                component="span"
                className={classes.typeOfAnalyticsLabel}
            >
                Type of Analytics
            </Typography>
            <Box className={classes.analyticsTypeButtons}>
                <Button
                    size="small"
                    variant={value === 0 ? 'contained' : 'outlined'}
                    className={
                        value === 0
                            ? classes.analyticsTypeButtonSelected
                            : classes.analyticsTypeButton
                    }
                    onClick={() => onChange(0)}
                >
                    Work Order
                </Button>
                <Button
                    size="small"
                    variant={value === 1 ? 'contained' : 'outlined'}
                    className={
                        value === 1
                            ? classes.analyticsTypeButtonSelected
                            : classes.analyticsTypeButton
                    }
                    onClick={() => onChange(1)}
                >
                    Financial
                </Button>
                <Button
                    size="small"
                    variant={value === 2 ? 'contained' : 'outlined'}
                    className={
                        value === 2
                            ? classes.analyticsTypeButtonSelected
                            : classes.analyticsTypeButton
                    }
                    onClick={() => onChange(2)}
                >
                    Area Status
                </Button>
            </Box>
        </Box>
    )
}
